import Vue from 'vue'

// setar em style  de imagem de perfil
Vue.filter('styleImgPerfil', function(fotoUser){
      if (fotoUser) {
        return 'background-image: url(/storage/users/'+ fotoUser +')'
      }else {
        return 'background-image: url(/img/avatar-p.png)'
      }
})

// setar bandeira do cartões pagseguro
Vue.filter('imgCardPagSeguroM', function(banco){
        return 'https://stc.pagseguro.uol.com.br' + banco.images.MEDIUM.path
})

// icone do fontowasome
Vue.filter('icoTipoPag', function(tipo_pag){
      switch (tipo_pag) {
        case 'boleto':
          return 'fa fa-barcode'
          break;
        case 'debito':
          return 'fa fa-credit-card-alt'
          break;
        case 'credito':
        case 'assinatura':
          return 'fa fa-credit-card'
          break;
        default:
          return ''
      }
})



// WEBPACK FOOTER //
// ./resources/assets/js/filters/img.js